// customborder.js
window.tinyMCE.PluginManager.add('customborder', function (editor) {
  function openBorderDialog(isVertical) {
    editor.windowManager.open({
      title: isVertical ? 'Insert Vertical Border' : 'Insert Horizontal Border',
      body: {
        type: 'panel',
        items: [
          {
            type: 'colorinput',
            name: 'borderColor',
            label: 'Color'
          },
          {
            type: 'input',
            name: 'borderWidth',
            label: 'Width (px)',
            value: '1' // Default width
          },
          {
            type: 'input',
            name: isVertical ? 'borderHeight' : 'borderSize',
            label: isVertical ? 'Height (px)' : 'Size (%)',
            value: '100' // Default size/height
          },
          {
            type: 'listbox',
            name: 'borderStyle',
            label: 'Style',
            items: [
              { text: 'Solid', value: 'solid' },
              { text: 'Dotted', value: 'dotted' },
              { text: 'Dashed', value: 'dashed' }
            ]
          },
          {
            type: 'listbox',
            name: 'borderAlignment',
            label: 'Alignment',
            items: [
              { text: 'Left', value: 'left' },
              { text: 'Center', value: 'center' },
              { text: 'Right', value: 'right' }
            ],
            value: 'left' // Default alignment
          }
        ]
      },
      buttons: [
        {
          text: 'Insert',
          type: 'submit',
          primary: true
        },
        {
          text: 'Cancel',
          type: 'cancel'
        }
      ],
      onSubmit: function (api) {
        const data = api.getData();
        const borderStyle = `border: none; ${isVertical ? 'border-left' : 'border-top'}: ${
          data.borderWidth || 1
        }px ${data.borderStyle || 'solid'} ${data.borderColor || '#000'}; ${
          isVertical ? `height: ${data.borderHeight || 100}px;` : 'height: 0;'
        }`;

        const alignmentStyle =
          data.borderAlignment === 'center'
            ? 'margin: 0 auto;'
            : data.borderAlignment === 'right'
            ? 'margin-left: auto;'
            : '';

        const borderContainer = isVertical
          ? `<div class="custom-border-container" contenteditable="false" style="display: inline-block; vertical-align: top; height: ${
              data.borderHeight || 100
            }px; float: ${
              data.borderAlignment
            }; ${alignmentStyle}"><div style="${borderStyle}"></div></div><div contenteditable="true" style="display: inline-block; vertical-align: top;">&nbsp;</div>`
          : `<div class="custom-border-container" contenteditable="false" style="display: block; width: ${
              data.borderSize || 100
            }%; ${alignmentStyle}"><div style="${borderStyle}"></div></div>`;

        editor.insertContent(borderContainer);
        api.close();
      }
    });
  }
  const horizontalBorderIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
    '<line x1="0" y1="12" x2="24" y2="12" stroke="black" stroke-width="2"/>' +
    '</svg>';
  editor.ui.registry.addIcon('customHorizontal', horizontalBorderIcon);

  editor.ui.registry.addButton('customhr', {
    icon: 'customHorizontal', // Use the customColumns icon
    tooltip: 'Add Horizontal border',
    onAction: function () {
      openBorderDialog(false);
    }
  });
  const verticalBorderIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
    '<line x1="12" y1="0" x2="12" y2="24" stroke="black" stroke-width="2"/>' +
    '</svg>';
  editor.ui.registry.addIcon('customVertical', verticalBorderIcon);

  editor.ui.registry.addButton('customvr', {
    icon: 'customVertical', // Use the customColumns icon
    tooltip: 'Add Vertical border',
    onAction: function () {
      openBorderDialog(true);
    }
  });

  // Prevent Enter key from duplicating borders
  editor.on('keydown', function (event) {
    if (event.keyCode === 13) {
      // Enter key
      const selectedNode = editor.selection.getNode();
      if (selectedNode && selectedNode.classList.contains('custom-border-container')) {
        event.preventDefault();
        editor.execCommand('mceInsertContent', false, '<p><br></p>');
      }
    }
  });
});
